import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "_flexcol _ai-c" }
const _hoisted_2 = { class: "_mt-2 _gap-2 _flex" }
const _hoisted_3 = { class: "_flexcol _jc-sb _gap-1" }
const _hoisted_4 = { class: "_grow-1 _pos-r _flex _ai-c _jc-c" }
const _hoisted_5 = { class: "gfu-avatar gfu-avatar-image" }
const _hoisted_6 = { class: "_flexcol _jc-sb _gap-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedSortActions, (buttons) => {
          return (_openBlock(), _createBlock(_component_base_button, {
            key: buttons.type,
            theme: "white",
            shape: "circle",
            shadow: "tight",
            onClick: $event => ($options.changeHash(buttons.type, $data.directions.prev)),
            "data-qa": "left-arrow-button"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_icon, {
                name: "chevron-left",
                class: "_tc--accent",
                size: "lg"
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.avatarModel, (image) => {
            return (_openBlock(), _createBlock(_component_base_image, {
              key: image.type,
              src: `/content/images/avatar/${image.type}/${image.pieceNumber}.png`,
              height: "140",
              width: "140",
              alt: "avatar",
              class: "_pos-a--cntr",
              "data-qa": `image-piece:${image.type}`
            }, null, 8 /* PROPS */, ["src", "data-qa"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedSortActions, (buttons) => {
          return (_openBlock(), _createBlock(_component_base_button, {
            key: buttons.type,
            theme: "white",
            shape: "circle",
            shadow: "tight",
            onClick: $event => ($options.changeHash(buttons.type, $data.directions.next)),
            "data-qa": `right-arrow-button:${buttons.type}`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_icon, {
                name: "chevron-right",
                class: "_tc--accent",
                size: "lg"
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick", "data-qa"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("a", {
      href: "#",
      class: "gfu-link gfu-link--accent _tac _mt-1",
      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.randomizeAvatar && $options.randomizeAvatar(...args)), ["prevent"]))
    }, [
      _createVNode(_component_base_icon, {
        name: "dice",
        class: "_tc--accent"
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.Resources.AccountSettings.AvatarManagerModalRandomizeAvatarLabel), 1 /* TEXT */)
    ])
  ]))
}